export const NO_INTEREST_DIVISION_CODE = {
  NORMAL: '10',
  INTEREST: '20',
  NO_INTEREST: '30',
};
